export enum ChartDataSoundStatus {
  NoSound = 'no_sound',
}
